/* eslint-disable no-use-before-define */
import React from "react";
import {
  ActivityIndicator,
  Button,
  Image,
  Platform,
  StyleSheet,
  Text,
  TextInput,
  View,
} from "react-native";
import { bindActionCreators } from "redux";
import { browserHistory } from "react-router";
import { connect } from "react-redux";
import storage from "../utils/storage";
import { RepositStyles } from "../utils/styles";
import {
  accessTokenItemName,
  backgroundRefreshAccessToken,
  changePassword,
  clearChangePassword,
  clearPasswordReset,
  disavowPasswordReset,
  loggedIn,
  login,
  logout,
  needsLogin,
  refreshAccessToken,
  refreshLogin,
  requestPasswordReset,
  updateVerifyPasswordResetToken,
  verifyPasswordResetToken,
} from "../redux/actions/user";
import "./LoginRequired.css";
import { TURNSTILE_SITE_KEY } from "../dev-config";

const mapStateToProps = (state) => ({
  user: state.user,
  routing: state.routing,
});

const mapDispatchToProps = (dispatch) => {
  return {
    userActions: bindActionCreators(
      {
        login,
        loggedIn,
        needsLogin,
        logout,
        requestPasswordReset,
        clearPasswordReset,
        disavowPasswordReset,
        verifyPasswordResetToken,
        updateVerifyPasswordResetToken,
        changePassword,
        clearChangePassword,
        refreshLogin,
        backgroundRefreshAccessToken,
        refreshAccessToken,
      },
      dispatch
    ),
  };
};

export let RefreshTokenTimeout;

class LoginRequired extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      username: "",
      password: "",
      captchaToken: null,
      scriptLoaded: false,
      turnstileRendered: false,
    };
    this.observer = null;
  }

  goToForgotPassword = () => {
    browserHistory.push("/password/forgot");
  };

  refreshLogin = (accessToken) => {
    if (accessToken) {
      try {
        RefreshTokenTimeout = setTimeout(this.refreshToken, 1800000);
        return this.props.userActions.refreshAccessToken();
      } catch (err) {
        console.log(err);
        return logout();
      }
    } else {
      // Force a logout if there is no token just to make sure all the state
      // is in the appropriate format.
      return logout();
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      this.props.user.loginStatus !== "LOGGED_IN" &&
      nextProps === "LOGGED_IN"
    ) {
      RefreshTokenTimeout = null;
    }
  }
  componentDidMount = () => {
    // eslint-disable-next-line
    if (
      !this.isPasswordForgot() &&
      !this.isPasswordReset() &&
      !this.isPasswordResetDisavow()
    ) {
      storage
        .load({ key: accessTokenItemName })
        .then((ret) => {
          this.refreshLogin(ret);
        })
        .catch((err) => {
          this.props.userActions.needsLogin();
        });
    }

    const checkScriptExists = () => {
      const script = !!window.turnstile;
      if (script) {
        this.setState({ scriptLoaded: true });
      }
    };

    this.observer = new MutationObserver(checkScriptExists);
    this.observer.observe(document, { childList: true, subtree: true });
    checkScriptExists();
  };

  componentDidUpdate(prevProps) {
    if (
      !prevProps.scriptLoaded &&
      !!this.state.scriptLoaded &&
      !this.state.turnstileRendered &&
      this.refs.containerRef
    ) {
      console.log(this.refs.containerRef);
      window.turnstile.render(this.refs.containerRef, {
        sitekey: TURNSTILE_SITE_KEY,
        theme: "light",
        callback: (token) => this.setState({ captchaToken: token }),
      });
      this.setState({ turnstileRendered: true });
    }
  }

  componentWillUnmount() {
    return () => {
      this.observer.disconnect();
    };
  }

  isPasswordForgot = () => {
    const currentLocation = browserHistory.getCurrentLocation();
    return currentLocation.pathname === "/password/forgot";
  };

  isPasswordReset = () => {
    const currentLocation = browserHistory.getCurrentLocation();
    return currentLocation.pathname === "/password/reset";
  };

  isPasswordResetDisavow = () => {
    const currentLocation = browserHistory.getCurrentLocation();
    return currentLocation.pathname === "/password/reset/disavow";
  };

  refreshToken = () => {
    this.props.userActions.backgroundRefreshAccessToken();
    RefreshTokenTimeout = setTimeout(this.refreshToken, 1800000);
  };

  login = () => {
    this.props.userActions.login(
      this.state.username,
      this.state.password,
      this.state.captchaToken
    );
    this.setState({ password: "" });
  };

  render() {
    const loginStatus = this.props.user.loginStatus;
    console.log(loginStatus);

    if (this.isPasswordForgot()) {
      return (
        <View style={styles.wrapper}>
          <ForgotForm
            user={this.props.user}
            requestPasswordReset={this.props.userActions.requestPasswordReset}
            clearPasswordReset={this.props.userActions.clearPasswordReset}
          />
        </View>
      );
    } else if (this.isPasswordReset()) {
      return (
        <View style={styles.wrapper}>
          <ResetForm
            user={this.props.user}
            clearPasswordReset={this.props.userActions.clearPasswordReset}
            clearChangePassword={this.props.userActions.clearChangePassword}
            verifyPasswordResetToken={
              this.props.userActions.verifyPasswordResetToken
            }
            changePassword={this.props.userActions.changePassword}
          />
        </View>
      );
    } else if (this.isPasswordResetDisavow()) {
      return <Disavow disavow={this.props.userActions.disavowPasswordReset} />;
    } else if (loginStatus === "FETCHING") {
      return (
        <View style={styles.wrapper}>
          <ActivityIndicator size="large" />
        </View>
      );
    } else if (loginStatus === "LOGGED_IN") {
      return Platform.OS === "web" ? (
        <span>{this.props.children}</span>
      ) : (
        <View style={styles.wrapper}>{this.props.children}</View>
      );
    } else {
      return (
        <View style={styles.wrapper}>
          <View
            style={{
              flex: 1,
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "column",
            }}
          >
            <Image
              style={{ width: 200, height: 150 }}
              resizeMode="contain"
              source={require("../img/Reposit_Mono.png")}
            />
            {!!TURNSTILE_SITE_KEY && !this.state.captchaToken && (
              <div ref={"containerRef"}></div>
            )}
            <View style={styles.textInputWrapper}>
              <View style={styles.textInputContainer}>
                <TextInput
                  autoCorrect={false}
                  autoCapitalize="none"
                  keyboardType="email-address"
                  placeholder="Email Address"
                  value={this.state.username}
                  onChangeText={(username) =>
                    this.setState({ username: username })
                  }
                  style={styles.textInput}
                />
              </View>
            </View>
            <View style={styles.textInputWrapper}>
              <View style={styles.textInputContainer}>
                <TextInput
                  autoCorrect={false}
                  secureTextEntry={true}
                  autoCapitalize="none"
                  placeholder="Password"
                  value={this.state.password}
                  onChangeText={(password) =>
                    this.setState({ password: password })
                  }
                  style={styles.textInput}
                  onSubmitEditing={() => this.login()}
                />
              </View>
            </View>
            {loginStatus === "ERROR" ? (
              <View>
                <Text>Incorrect username or password, please try again</Text>
              </View>
            ) : null}
            <View style={{ marginVertical: 30, width: 100 }}>
              <Button
                title="Sign in"
                onPress={() => {
                  this.login();
                }}
                disabled={this.state.captchaToken === null}
                color="#4698CB"
              />
            </View>
            <View style={{ flex: 2 }} />
            <a
              href="/password/forgot"
              className="link"
              onClick={this.goToForgotPassword}
              style={{ ...RepositStyles.paragraphText, textAlign: "center" }}
            >
              Forgot your Password?
            </a>
            <Text
              style={{
                ...RepositStyles.paragraphText,
                marginBottom: 20,
                marginTop: 50,
                textAlign: "center",
              }}
            >
              On mobile? Get the new mobile installer apps:
            </Text>
            <View style={{ flexDirection: "row" }}>
              <a href="https://itunes.apple.com/au/app/reposit-installer/id1261313006">
                <img
                  src="https://gridportal.repositpower.com/app-store-badge.svg"
                  alt="App Store Reposit App"
                  style={{ height: 40, marginRight: 10 }}
                />
              </a>
              <a href="https://play.google.com/store/apps/details?id=com.repositpower.installerapp">
                <img
                  src="https://gridportal.repositpower.com/google-play-badge.png"
                  alt="Google Play Reposit App"
                  style={{ height: 40, marginLeft: 10 }}
                />
              </a>
            </View>
          </View>
        </View>
      );
    }
  }
}

const styles = StyleSheet.create({
  wrapper: {
    backgroundColor: "white",
    flex: 1,
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
  },
  heading: {
    borderBottomWidth: StyleSheet.hairlineWidth,
    borderBottomColor: "#DFE6F5",
    marginHorizontal: 20,
  },
  headingText: { fontSize: 32, textAlign: "center", fontWeight: "300" },
  text: {
    textAlign: "center",
    fontSize: 20,
    fontWeight: "300",
    marginHorizontal: 20,
    marginVertical: 10,
  },
  bodyText: {
    marginVertical: 10,
  },
  textInput: {
    textAlign: "center",
    height: Platform.OS === "android" ? 50 : 30,
  },
  textInputWrapper: {
    alignItems: "center",
  },
  textInputContainer: {
    width: 250,
    borderBottomWidth: Platform.OS === "android" ? 0 : 1,
    marginVertical: 15,
  },
});

class ForgotForm extends React.Component {
  constructor() {
    super();
    this.state = {
      email: "",
    };
  }

  componentWillUnmount = () => {
    this.props.clearPasswordReset();
  };

  handleEmailChange = (event) => {
    this.setState({ email: event.target.value });
  };

  goToLogin = () => {
    browserHistory.push("/");
  };

  requestPasswordReset = (e) => {
    e.preventDefault();
    this.props.requestPasswordReset(this.state.email);
  };

  render() {
    if (
      this.props.user.passwordReset &&
      this.props.user.passwordReset.status === "FETCHING"
    ) {
      return (
        <View style={styles.wrapper}>
          <ActivityIndicator size="large" />
        </View>
      );
    } else if (
      this.props.user.passwordReset &&
      this.props.user.passwordReset.status === "OK"
    ) {
      return (
        <span>
          <div style={{ textAlign: "center", marginTop: 20 }}>
            <Text
              style={{ ...RepositStyles.paragraphText, marginHorizontal: 30 }}
            >
              {this.props.user.passwordReset.message}
            </Text>
            <div className="login-links">
              <a href="/" className="link" onClick={this.goToLogin}>
                Back to Login
              </a>
            </div>
          </div>
        </span>
      );
    } else {
      return (
        <span>
          <div className="message-container">
            {this.props.user.passwordReset &&
            this.props.user.passwordReset.status === "ERROR" ? (
              <div className="message">
                Well that didn't work. Please try again.
              </div>
            ) : null}
          </div>
          <View>
            <Text style={{ ...RepositStyles.paragraphText, marginTop: 30 }}>
              Enter your email address below to reset your password. You will be
              sent an email which you will need to open to continue. You may
              need to check your spam folder.
            </Text>
          </View>
          <div style={{ textAlign: "center" }}>
            <form className="login-form" onSubmit={this.requestPasswordReset}>
              <p>
                <label htmlFor="login-username">Email</label>
                <input
                  id="login-username"
                  type="text"
                  onChange={this.handleEmailChange}
                  autoComplete="off"
                  value={this.state.email}
                />
              </p>
              <p>
                <input type="submit" value="Send Password Reset" />
              </p>
            </form>
            <div className="login-links">
              <a href="/" className="link" onClick={this.goToLogin}>
                Back to Login
              </a>
            </div>
          </div>
        </span>
      );
    }
  }
}

class ResetForm extends React.Component {
  constructor() {
    super();
    this.state = {
      password: "",
      confirmPassword: "",
    };
  }

  componentDidMount = () => {
    const token = this.getToken();
    this.props.verifyPasswordResetToken(token);
  };

  componentWillUnmount = () => {
    this.props.clearPasswordReset();
  };

  getToken = () => {
    const currentLocation = browserHistory.getCurrentLocation();
    return currentLocation.query.token;
  };

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  };

  handleConfirmPasswordChange = (event) => {
    this.setState({ confirmPassword: event.target.value });
  };

  resetPasswordChange = () => {
    this.props.clearChangePassword();
    this.setState({
      validationMessage: "",
    });
  };

  changePassword = (e) => {
    e.preventDefault();
    this.resetPasswordChange();
    if (this.state.password !== this.state.confirmPassword) {
      this.setState({ validationMessage: "Passwords do not match" });
      return;
    }

    this.props.changePassword(
      this.state.password,
      this.state.confirmPassword,
      this.getToken()
    );
  };

  render() {
    if (
      this.props.user.passwordReset &&
      (this.props.user.passwordReset.status === "FETCHING" ||
        this.props.user.passwordReset.status === undefined)
    ) {
      return (
        <View style={styles.wrapper}>
          <ActivityIndicator size="large" />
        </View>
      );
    } else if (
      this.props.user.passwordReset &&
      this.props.user.passwordReset.tokenValid === false
    ) {
      return (
        <span>
          <div className="message-container">
            <div className="message">
              Your reset password link is no longer valid. You may request a new
              password reset by visiting the{" "}
              <a href="/password/forgot">Forgot Password</a> form.
            </div>
          </div>
        </span>
      );
    } else if (
      this.props.user.passwordReset &&
      this.props.user.passwordReset.status === "PASSWORD_RESET"
    ) {
      return (
        <span>
          <div className="message-container">
            <div className="message">
              Your password has been reset. You may now <a href="/">login</a> to
              Reposit Installer.
            </div>
          </div>
        </span>
      );
    } else {
      return (
        <span>
          <div className="message-container reset-password">
            {(this.props.user.passwordReset &&
              this.props.user.passwordReset.status === "ERROR") ||
            this.state.validationMessage ? (
              <div className="message validation">
                {this.props.user.passwordReset.status === "ERROR"
                  ? this.props.user.passwordReset.message
                    ? this.props.user.passwordReset.message
                    : "Well that didn't work. Please try again."
                  : null}
                {this.props.user.passwordReset &&
                this.props.user.passwordReset.status === "ERROR" &&
                this.state.validationMessage ? (
                  <br />
                ) : null}
                {this.state.validationMessage}
              </div>
            ) : null}
          </div>
          <View style={{ ...RepositStyles.paragraphText, marginTop: 20 }}>
            <Text style={RepositStyles.paragraphText}>
              Your password must:
              <ul>
                <li>not be too common,</li>
                <li>be at least 8 characters in length,</li>
                <li>
                  contain at least 3 of the following:
                  <ul>
                    <li>Lower case letters (a-z),</li>
                    <li>Upper case letters (A-Z),</li>
                    <li>Numbers (0-9).</li>
                    <li>Special characters (e.g. !@#$%^&* )</li>
                  </ul>
                </li>
              </ul>
            </Text>
            <form className="login-form" onSubmit={this.changePassword}>
              <p>
                <label htmlFor="reset-password">New Password</label>
                <input
                  autoComplete="off"
                  id="reset-password"
                  type="password"
                  onChange={this.handlePasswordChange}
                  value={this.state.password}
                />
              </p>
              <p>
                <label htmlFor="reset-password-confirm">
                  Confirm New Password
                </label>
                <input
                  autoComplete="off"
                  id="reset-password-confirm"
                  type="password"
                  onChange={this.handleConfirmPasswordChange}
                  value={this.state.confirmPassword}
                />
              </p>
              <p style={{ textAlign: "center" }}>
                <input type="submit" value="Reset Password" />
              </p>
            </form>
            <div></div>
          </View>
        </span>
      );
    }
  }
}

class Disavow extends React.Component {
  componentDidMount = () => {
    const currentLocation = browserHistory.getCurrentLocation();
    const token = currentLocation.query.token;
    this.props.disavow(token);
  };

  render() {
    return (
      <span>
        <div className="message-container">
          <div className="message">
            Your password reset link has been deactivated. An email has been
            sent to support.
          </div>
        </div>
      </span>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginRequired);



// WEBPACK FOOTER //
// ./src/layouts/LoginRequired.web.js